import { commonParams } from "../endpoint/EndpointParameters";
import { de_CreateEmailNotificationCommand, se_CreateEmailNotificationCommand, } from "../protocols/Aws_restJson1";
import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
export class CreateEmailNotificationCommand extends $Command.classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("TempeFabricationPublic", "CreateEmailNotification", {})
    .n("TempeFabricationPublicClient", "CreateEmailNotificationCommand").f(void 0, void 0)
    .ser(se_CreateEmailNotificationCommand)
    .de(de_CreateEmailNotificationCommand)
    .build() {
}
